'use client';

import MenuItem from '@mui/material/MenuItem';
import { useNumberOfQuestionsComponent } from './useNumberOfQuestionsComponent';

import { useTranslation } from 'react-i18next';
import SelectComponent from '@/shared/SelectComponent';
import { QuestionCountOptions } from '@/types';
import { Grid } from '@mui/material';
const NumberOfQuestionsComponent = () => {
  const { t } = useTranslation();

  const { handleChange, numberOfQuestions } = useNumberOfQuestionsComponent();
  const selectOptions = Object.keys(QuestionCountOptions).map((m) => (
    <MenuItem key={m} value={m}>
      {t(QuestionCountOptions[Number.parseInt(m, 10) as keyof typeof QuestionCountOptions])}
    </MenuItem>
  ));

  return (
    <Grid container>
      <Grid display='flex' justifyContent='center' alignItems='center' size={12}>
        <SelectComponent
          labelId='no-of-questions-select-label'
          selectId='no-of-questions-select'
          selectOptions={selectOptions}
          formControlSx={{ m: 1, minWidth: 216 }}
          selectedValue={numberOfQuestions}
          handleChange={handleChange}
          selectLabel={t('number-of-question-selector.select-1.label')}
        />
      </Grid>
    </Grid>
  );
};

export default NumberOfQuestionsComponent;
